import { inject } from '@angular/core'
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http'
import { EMPTY, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { CognitoService } from '../services/cognito.service'
import { Router } from '@angular/router'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const cognitoService = inject(CognitoService)
  const router = inject(Router)

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        // Save current URL so user returns here after SSO login
        sessionStorage.setItem('preAuthUrl', router.url)
        // Token expired or invalid — redirect to SSO login
        cognitoService.loginRedirect()
        return EMPTY
      }
      return throwError(() => error)
    })
  )
}
